import { URL_LABEL } from "../../../index.content";

const proAiExtension = ({ language, isSavedUser }) => {
  return {
    title: "PRO AI Extension",
    url: isSavedUser
      ? `${process.env.SCOUT_EXT_PRO_NEW}?utm_source=site&utm_medium=amzscout&utm_campaign=footer`
      : `/pro-ai/?${URL_LABEL}`,
    target: isSavedUser,
    ref: false,
    isLink: !isSavedUser,
    showMobileProPopup: isSavedUser,
  };
};

export default proAiExtension;
